/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import Text from 'src/components/ts-components/Text'
import { useDivisionSetupContext } from '../../context'
import { SwitchInput } from 'src/components/ts-components/SwitchInput'
import CurrencyInput from 'src/components/ts-components/CurrencyInput'
import { TextInput } from 'src/components/ts-components/TextInput'
import { SelectInput } from 'src/components/ts-components/SelectInput'
import DatePicker from 'src/components/ts-components/DatePicker'
import dayjs from 'dayjs'
import colors from '@sportninja/common/constants/appColors'

const Payments = () => {
  const { state, setState } = useDivisionSetupContext()

  return (
    <div
      css={css`
        display: flex;
        padding: 16px;
        gap: 16px;
        flex-direction: column;
        align-items: flex-end;
        max-height: 80vh;
        overflow-y: auto;
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          gap: 8px;
          align-self: stretch;
        `}
      >
        <Text variant='captionLarge' weight='semiBold'>
          Team Payments
        </Text>
      </div>
      <div
        css={css`
          display: flex;
          align-items: flex-start;
          gap: 16px;
          align-self: stretch;
        `}
      >
        <SwitchInput
          title='Require Payment'
          subtitle=''
          value={state.requirePayment}
          onChange={(value) => {
            if (value === false) {
              setState((prev) => ({
                ...prev,
                requirePayment: value,
                requireDeposit: false,
                costPerRegistration: null,
                deposit: null,
                numberOfInstallments: null,
                installmentFrequency: null,
                installmentStartDate: null,
              }))
            } else {
              setState((prev) => ({
                ...prev,
                requirePayment: value,
                numberOfInstallments: 1,
              }))
            }
          }}
        />
      </div>
      {state?.requirePayment ? (
        <div
          css={css`
            width: 100%;
            height: 1px;
            background-color: ${colors.NEUTRAL_100};
            border-bottom: 1px solid ${colors.NEUTRAL_100};
          `}
        />
      ) : null}
      {state?.requirePayment ? (
        <div
          css={css`
            display: flex;
            align-items: flex-start;
            gap: 16px;
            align-self: stretch;
          `}
        >
          <SwitchInput
            title='One Time Payment'
            subtitle='Users will have to pay in full at the registration time.'
            value={state.oneTimePayment}
            onChange={(value) => {
              setState((prev) => ({
                ...prev,
                oneTimePayment: value,
                numberOfInstallments: value ? 1 : prev.numberOfInstallments,
                installmentFrequency: value ? '' : prev.installmentFrequency,
                installmentStartDate: value ? '' : prev.installmentStartDate,
                requireDeposit: value ? false : prev.requireDeposit,
                deposit: value ? 0 : prev.deposit,
              }))
            }}
          />
        </div>
      ) : null}
      {state?.requirePayment ? (
        <div
          css={css`
            width: 100%;
            height: 1px;
            background-color: ${colors.NEUTRAL_100};
            border-bottom: 1px solid ${colors.NEUTRAL_100};
          `}
        />
      ) : null}
      {state?.requirePayment ? (
        <div
          css={css`
            display: flex;
            align-items: flex-start;
            gap: 16px;
            align-self: stretch;
            @media (max-width: 768px) {
              flex-direction: column;
            }
          `}
        >
          <div
            css={css`
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              gap: 8px;
              flex: 1 0 0;
              @media (max-width: 768px) {
                width: 100%;
              }
            `}
          >
            <CurrencyInput
              label='Cost Per Registration *'
              value={state.costPerRegistration || 0}
              onChange={(value) => {
                setState((prev) => ({
                  ...prev,
                  costPerRegistration: Number(value),
                }))
              }}
              fieldErrors={state?.fieldErrors || []}
              customError={state?.customError || ''}
              name='costPerRegistration'
            />
          </div>
        </div>
      ) : null}
      {/* separator */}
      {!state.oneTimePayment && state?.requirePayment && (
        <div
          css={css`
            width: 100%;
            height: 1px;
            background-color: ${colors.NEUTRAL_100};
            border-bottom: 1px solid ${colors.NEUTRAL_100};
          `}
        />
      )}
      {!state.oneTimePayment && state?.requirePayment && (
        <div
          css={css`
            display: flex;
            align-items: flex-start;
            gap: 16px;
            align-self: stretch;
            @media (max-width: 768px) {
              flex-direction: column;
            }
          `}
        >
          <div
            css={css`
              display: flex;
              align-items: flex-start;
              gap: 16px;
              align-self: stretch;
              width: 100%;
            `}
          >
            <SwitchInput
              title='Require Deposit'
              subtitle=''
              value={state.requireDeposit}
              onChange={(value) => {
                if (value === false) {
                  setState((prev) => ({
                    ...prev,
                    requireDeposit: value,
                    deposit: null,
                  }))
                } else {
                  setState((prev) => ({ ...prev, requireDeposit: value }))
                }
              }}
            />
          </div>
        </div>
      )}
      {!state.oneTimePayment && state?.requireDeposit ? (
        <div
          css={css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
            flex: 1 0 0;
            width: 100%;
            @media (max-width: 768px) {
              width: 100%;
            }
          `}
        >
          <CurrencyInput
            label='Deposit'
            value={state.deposit || 0}
            onChange={(value) => {
              setState((prev) => ({ ...prev, deposit: Number(value) }))
            }}
            name='deposit'
            fieldErrors={state?.fieldErrors || []}
            customError={state?.customError || ''}
          />
        </div>
      ) : null}
      {!state.oneTimePayment ? (
        <div
          css={css`
            width: 100%;
            height: 1px;
            background-color: ${colors.NEUTRAL_100};
            border-bottom: 1px solid ${colors.NEUTRAL_100};
          `}
        />
      ) : null}
      {!state.oneTimePayment && state?.requirePayment && (
        <div
          css={css`
            display: flex;
            align-items: flex-start;
            gap: 16px;
            align-self: stretch;
            @media (max-width: 768px) {
              flex-direction: column;
            }
          `}
        >
          <div
            css={css`
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              gap: 8px;
              flex: 1 0 0;
              @media (max-width: 768px) {
                width: 100%;
              }
            `}
          >
            <TextInput
              label='Number of Installments'
              value={state?.numberOfInstallments?.toString() || ''}
              setValue={(value) => {
                setState((prevState) => ({
                  ...prevState,
                  numberOfInstallments: parseInt(value, 10),
                }))
              }}
              fieldErrors={state?.fieldErrors || []}
              customError={state?.customError || ''}
              disabled={false}
              name='installments'
              type='number'
              min={1}
            />
          </div>
          {state?.numberOfInstallments && state?.numberOfInstallments > 1 ? (
            <div
              css={css`
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 8px;
                flex: 1 0 0;
                @media (max-width: 768px) {
                  width: 100%;
                }
              `}
            >
              <SelectInput
                label='Installment Frequency'
                options={[
                  { label: 'Weekly', value: '0' },
                  { label: 'Bi-Weekly', value: '1' },
                  { label: 'Monthly', value: '2' },
                  { label: 'Bi-Monthly', value: '3' },
                  { label: 'Quarterly', value: '4' },
                  { label: 'Semi-Annually', value: '5' },
                  { label: 'Annually', value: '6' },
                ]}
                value={state.installmentFrequency || '0'}
                onChange={(value) => {
                  setState({
                    ...state,
                    installmentFrequency: value as string,
                  })
                }}
                fieldErrors={state.fieldErrors}
                customError={state.customError}
                disabled={false}
                name='installment_frequency'
              />
            </div>
          ) : null}
          <DatePicker
            label='Installment Start Date'
            value={
              state.installmentStartDate
                ? dayjs(state.installmentStartDate).utc()
                : dayjs().utc()
            }
            onChange={(value) => {
              setState({
                ...state,
                installmentStartDate: value
                  ? value.utc().format('YYYY-MM-DD')
                  : dayjs().utc().format('YYYY-MM-DD'),
              })
            }}
          />
        </div>
      )}
    </div>
  )
}

export default Payments
